
export default {
    name: 'FilterSortingMobile',
    props: {
        filterTitle: {
            type: String,
            required: true,
            default: '',
        },
        actualValue: {
            required: true,
            // default: () => {},
        },
        filterOptions: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
    methods: {
        handleClickOption(option) {
            this.$emit('update:actualValue', option);
        }
    }
}
